import { NotFound } from "components/molecules/404"
import React from "react"

export const NotFoundPage = () => {
  return <NotFound />
}
